import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationUserEmailActivatePatch = {
    path: "/user/email/activate",
    method: ERouteHttpVerb.PATCH
};
export { routeLocationUserEmailActivatePatch };
